/* =====================================================================
   08 Wheels and parts (sections/ez-wheels-finder.liquid), homepage v2.
   Runs on the shared runtime window.EZH (assets/ez-home.js, loaded first by
   snippets/ez-home-assets.liquid). No libraries.

   - One EZH.mover per section. It drives the disc (CSS: .is-paused pauses the
     turn) and the code demo. Holds: the pause pill, pause all, off screen
     (15% visible), a hidden tab, reduced motion, and keyboard focus inside the
     section except in the box (a text box always matches :focus-visible, so a
     click into it would otherwise freeze the disc). Hover is never a hold.
   - The demo types real codes (chips marked data-ezw-demo) into the box's
     PLACEHOLDER only, never its value: 150 ms a character, the matching chip
     lights and holds 1.7 s, then 60 ms a character back out, then the next
     code. It stops for good on pointerdown, focus or keydown in the box, or
     pointerdown or focus on the button, and the resting placeholder returns.
   - Typing lights the chips whose code starts with what is typed (or whose
     "fits" line contains it, from 3 letters). Others are never dimmed.
   - Find wheels: empty box -> the wheels collection; a code that equals a chip,
     or starts exactly one chip -> that product; anything else -> the normal
     GET /search (products, prefix match).
   ===================================================================== */
(function () {
  'use strict';
  var TYPE = 150, HOLD = 1700, ERASE = 60, GAP = 500, FIRST = 700;

  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function isKb(t) { try { return t.matches(':focus-visible'); } catch (e) { return false; } }

  function setup(root) {
    var EZH = window.EZH;
    if (!EZH || root.__ezw) return;
    var form = root.querySelector('[data-ezw-form]');
    var input = root.querySelector('[data-ezw-input]');
    if (!form || !input) return;
    root.__ezw = true;

    var btn = form.querySelector('[type="submit"]');
    var status = root.querySelector('[data-ezw-status]');
    var chips = [].slice.call(root.querySelectorAll('[data-ezw-code]'));
    chips.forEach(function (c) {
      c.__code = norm(c.getAttribute('data-ezw-code'));
      c.__fits = (c.getAttribute('data-ezw-fits') || '').toLowerCase();
    });
    var words = chips.filter(function (c) { return c.hasAttribute('data-ezw-demo'); })
      .map(function (c) { return c.getAttribute('data-ezw-code'); })
      .filter(Boolean);
    var rest = input.getAttribute('placeholder') || '';
    var st = { owned: false, timer: 0, wi: 0, k: 0, phase: 'idle' };
    var sayT = 0;

    function light(v) {
      var q = norm(v), f = String(v || '').toLowerCase().trim(), hits = [];
      chips.forEach(function (c) {
        var hit = q.length > 0 && (c.__code.indexOf(q) === 0 || (f.length > 2 && c.__fits.indexOf(f) > -1));
        c.classList.toggle('is-hit', hit);
        if (hit) hits.push(c);
      });
      return hits;
    }
    function show(t) { input.setAttribute('placeholder', t); }
    function reset() {
      clearTimeout(st.timer);
      st.phase = 'idle'; st.k = 0;
      show(rest);
      light(st.owned ? input.value : '');
    }
    function schedule(ms) { clearTimeout(st.timer); st.timer = setTimeout(step, ms); }

    function step() {
      if (st.owned || !m.running || !words.length) return;
      var w = words[st.wi % words.length];
      if (st.phase === 'idle' || st.phase === 'gap') { st.phase = 'type'; st.k = 0; }
      if (st.phase === 'type') {
        st.k = Math.min(w.length, st.k + 1);
        show(w.slice(0, st.k)); light(w.slice(0, st.k));
        if (st.k >= w.length) { st.phase = 'hold'; schedule(HOLD); } else schedule(TYPE);
        return;
      }
      if (st.phase === 'hold') st.phase = 'erase';
      st.k = Math.max(0, st.k - 1);
      var t = w.slice(0, st.k);
      show(t); light(t);
      if (st.k === 0) { st.phase = 'gap'; st.wi++; schedule(GAP); } else schedule(ERASE);
    }
    function resume() {
      if (st.owned || !words.length) return;
      schedule(st.phase === 'type' ? TYPE : st.phase === 'erase' ? ERASE : st.phase === 'hold' ? HOLD
        : st.phase === 'gap' ? GAP : FIRST);
    }

    var m = EZH.mover(root, {
      reduced: 'stop',
      threshold: 0.15,
      focusHold: false,
      start: resume,
      stop: function (mm) {
        clearTimeout(st.timer);
        if (mm.is('reduced')) reset();     // reduced motion: back to the plain resting placeholder
      }
    });

    // the shopper takes over: the demo stops for good
    function own() {
      if (st.owned) return;
      st.owned = true;
      root.setAttribute('data-ezw-owned', '');
      reset();
    }
    ['pointerdown', 'focus', 'keydown'].forEach(function (ev) { input.addEventListener(ev, own); });
    if (btn) ['pointerdown', 'focus'].forEach(function (ev) { btn.addEventListener(ev, own); });

    function say(hits) {
      if (!status) return;
      var v = input.value.trim();
      if (!v) { status.textContent = ''; return; }
      if (!hits.length) { status.textContent = 'No code matches ' + v + '. Find wheels searches the shop.'; return; }
      var names = hits.map(function (c) { return c.getAttribute('data-ezw-code'); }).join(', ');
      status.textContent = hits.length === 1
        ? '1 match: ' + names + ', ' + hits[0].__fits + '.'
        : hits.length + ' matches: ' + names + '.';
    }
    input.addEventListener('input', function () {
      own();
      var hits = light(input.value);
      clearTimeout(sayT);
      sayT = setTimeout(function () { say(hits); }, 450);
    });

    form.addEventListener('submit', function (e) {
      own();
      var q = norm(input.value);
      if (!q) {
        e.preventDefault();
        location.href = form.getAttribute('data-ezw-empty') || '/collections/replacement-wheels';
        return;
      }
      var hit = null;
      chips.forEach(function (c) { if (!hit && c.__code === q) hit = c; });
      if (!hit) {
        var pre = chips.filter(function (c) { return c.__code.indexOf(q) === 0; });
        if (pre.length === 1) hit = pre[0];
      }
      if (hit) { e.preventDefault(); location.href = hit.href; }
    });

    // keyboard hold: tabbing onto a chip, the disc or the button holds the disc and the demo
    root.addEventListener('focusin', function (e) {
      var t = e.target;
      m.hold('kb', isKb(t) && t !== input && !(m.button && m.button.contains(t)));
    });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) m.hold('kb', false); });

    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target.contains(root)) { clearTimeout(st.timer); clearTimeout(sayT); }
    });
    root.__ezwState = st;   // for tests
  }

  function init(scope) { [].forEach.call((scope || document).querySelectorAll('[data-ezw]'), setup); }
  if (window.EZH) init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
